/*
 * KPS Otomotiv paneli — yalnızca web sitesinin kullandığı modüller.
 * Sitede karşılığı olmayan eski modüller (Pop-Up, Arge, Whatsapp, Ürün Listesi, Hizmetler, Galeri)
 * menüden kaldırıldı; rotaları duruyor, gerekirse aşağıdaki listeye geri eklenebilir.
 */
export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Site Genel',
    route: null,
    icon: 'GlobeIcon',
    children: [
      {
        title: 'Site Menü',
        route: 'SiteMenus',
        resource: 'ADMIN_SITE_MENU',
        action: 'read',
      },
      {
        title: 'Anasayfa Video',
        route: 'Carousel',
        resource: 'ADMIN_CAROUSEL',
        action: 'read',
      },
      {
        title: 'İçerik Blokları',
        route: 'SiteBlocks',
        resource: 'ADMIN_SITE_BLOCKS',
        action: 'read',
      },
      {
        title: 'Sayfalar',
        route: 'Contents',
        resource: 'ADMIN_CONTENTS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kurumsal',
    route: null,
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Hakkımızda',
        route: 'About',
        resource: 'ADMIN_ABOUT',
        action: 'read',
      },
      {
        title: 'Sertifikalar',
        route: 'Certificates',
        resource: 'ADMIN_CERTIFICATES_LIST',
        action: 'read',
      },
      {
        title: 'Referanslar',
        route: 'References',
        resource: 'ADMIN_REFERENCES_LIST',
        action: 'read',
      },
      {
        title: 'İletişim Bilgileri',
        route: 'Contacts',
        resource: 'ADMIN_CONTACT',
        action: 'read',
      },
    ],
  },
  {
    title: 'Üretim',
    route: null,
    icon: 'ApertureIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'ProductionAdd',
        resource: 'ADMIN_PRODUCTION_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Production',
        resource: 'ADMIN_PRODUCTION_LIST',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ürün Grupları',
    route: 'ProductGroups',
    icon: 'BoxIcon',
    resource: 'ADMIN_PRODUCTS',
    action: 'read',
  },
  {
    title: 'Haberler',
    route: null,
    icon: 'BookIcon',
    children: [
      {
        title: 'Oluştur',
        route: 'BlogAdd',
        resource: 'ADMIN_BLOG_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Blog',
        resource: 'ADMIN_BLOG_LIST',
        action: 'read',
      },
      {
        title: 'Kategoriler',
        route: 'BlogCategories',
        resource: 'ADMIN_BLOG_CATEGORIES_LIST',
        action: 'read',
      },
    ],
  },
  {
    title: 'Formlar',
    route: null,
    icon: 'EditIcon',
    children: [
      {
        title: 'İletişim Formları',
        route: 'WebForms',
        resource: 'ADMIN_WEBFORMS',
        action: 'read',
      },
      {
        title: 'Kariyer Başvuruları',
        route: 'HrForms',
        resource: 'ADMIN_HR_FORMS_LIST',
        action: 'read',
      },
    ],
  },
  {
    title: 'Sosyal Medya',
    route: 'Socialmedia',
    icon: 'Share2Icon',
    resource: 'ADMIN_MODULES',
    action: 'read',
  },
  {
    title: 'Dil Çeviri',
    route: 'Translate',
    icon: 'FlagIcon',
    resource: 'ADMIN_TRANSLATE',
    action: 'read',
  },
  {
    title: 'Kullanıcılar',
    route: null,
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ayarlar',
    route: null,
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Genel Yapılandırma',
        route: 'Configs',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SEO Ayarları',
        route: 'Components',
        resource: 'ADMIN_CONFIG',
        action: 'read',
      },
      {
        title: 'SMTP',
        route: 'Smtp',
        resource: 'ADMIN_SMTP',
        action: 'read',
      },
    ],
  },
]
